import { Button, Input, Typography } from '@breetometer/components';
import { ModalParts, NotificationBanner } from 'BreetComponents';
import { onFormPreventDefault } from 'BreetHelpers';
import { useFormData, useModalApi } from 'BreetHooks';
import { setExportEndDate, setExportStartDate, useAppDispatch } from 'BreetRedux';
import { useCallback } from 'react';

import { FileExportSchema } from './DialogFileExport.helpers';

const DialogFileExport = () => {
	const dispatch = useAppDispatch();

	const { closeModalDirect } = useModalApi();

	const { isFormCompleted, hookFormProps } = useFormData(FileExportSchema);

	const onExport = useCallback(() => {
		dispatch(setExportStartDate(hookFormProps.watch('exportStartDate')));
		dispatch(setExportEndDate(hookFormProps.watch('exportEndDate')));
		closeModalDirect('fileExport');
	}, [closeModalDirect, dispatch, hookFormProps]);

	return (
		<ModalParts.Wrapper
			title='Export'
			root='Export'
			rightSheet
		>
			<div className='dialog-export'>
				<Typography
					className='color-neutral-50'
					as='h5'
				>
					Select date range for your file export
				</Typography>
				<form
					className='new-drop-down-input'
					onSubmit={onFormPreventDefault}
				>
					<Input
						label='Start Date'
						id='export'
						type='date'
						widthType='full'
						required
						{...hookFormProps.register('exportStartDate')}
						errorMessage={hookFormProps.formState.errors.exportStartDate?.message}
					/>

					<Input
						label='End Date'
						id='export'
						type='date'
						widthType='full'
						required
						{...hookFormProps.register('exportEndDate')}
						errorMessage={hookFormProps.formState.errors.exportEndDate?.message}
					/>

					<NotificationBanner
						type='standard'
						status='success'
						mood='black-white'
						message='Your file will be downloaded once the export is ready'
					/>

					<div className='cta'>
						<Button
							disabled={!isFormCompleted}
							type='button'
							onClick={onExport}
						>
							Export
						</Button>
					</div>
				</form>
			</div>
		</ModalParts.Wrapper>
	);
};

export default DialogFileExport;
